import * as yup from "yup";

const voluntaryWorkSchema = yup.object({
    organisationName: yup
        .string()
        .trim()
        .required("Organisation name is required."),

    startDate: yup.string().nullable().required("Start date is required.")
});

export default voluntaryWorkSchema;
